module.exports = "https://cdn-assessment.mathletics.com/app/102/assets/images/bc87eef69cb57081ee4e07fc0ba17ba0.svg";